// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WpAi","importantInfo":"styles_importantInfo__2YpWo"};